<template>
  <button
    class="button"
    @click="onClick"
  >
    <icon-plus
      v-if="isCollapsed"
      key="minus"
      class="button__icon"/>
    <icon-minus
      v-else
      key="plus"
      class="button__icon"/>
  </button>
</template>

<script>
import IconMinus from '@/mikan/_shared/components/atoms/icons/IconMinus.vue';
import IconPlus from '@/mikan/_shared/components/atoms/icons/IconPlus.vue';

export default {
  components: {
    IconMinus,
    IconPlus,
  },
  model: {
    prop: 'isCollapsed',
    event: 'toggle',
  },
  props: {
    isCollapsed: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onClick() {
      this.$emit('toggle', !this.isCollapsed);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background-color: transparent;
  color: $color-navy-20;
  line-height: 1;
  outline: none;
  transition: color $transition-base;

  @include is-pointer-device {
    &:hover {
      color: $color-sky-blue;
      cursor: pointer;
    }
  }

  &__icon {
    color: inherit;
    font-size: inherit;
  }
}
</style>
